import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

// Pages
import Index from '../pages/Index';
import PersonalData from '../pages/PersonalData';
import AddressData from '../pages/AddressData';
import KnownInfoSelection from '../pages/KnownInfoSelection';
import AddressDetails from '../pages/AddressDetails';
import Birthdate from '../pages/Birthdate';
import BothInfo from '../pages/BothInfo';
import NoInfo from '../pages/NoInfo';
import Email from '../pages/Email';
import Loading from '../pages/Loading';
import Payment from '../pages/Payment';
import BankTransfer from '../pages/BankTransfer';
import Success from '../pages/Success';
import VerificationSuccess from '../pages/VerificationSuccess';
import Processing from '../pages/Processing';
import Legal from '../pages/Legal';
import NotFound from '../pages/NotFound';
import Impressum from '../pages/Impressum';
import AGB from '../pages/AGB';
import Datenschutz from '../pages/Datenschutz';
import LieferungenLeistung from '../pages/LieferungenLeistung';
import Widerrufsbelehrung from '../pages/Widerrufsbelehrung';
import Kontaktformular from '../pages/Kontaktformular';
import VertragWiderrufen from '../pages/VertragWiderrufen';
import Erfahrungen from '../pages/Erfahrungen';

// Einwohnermeldeamt Pages
import EinwohnermeldeamtIndex from '../pages/Einwohnermeldeamt/Index';
import BundeslandPage from '../pages/Einwohnermeldeamt/BundeslandPage';
import LocationPage from '../pages/Einwohnermeldeamt/LocationPage';

const AppRoutes: React.FC = () => {
  const { pathname } = useLocation();
  
  // Scroll to top and track page view when pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);

    // Send page_view event to Google Ads/Analytics for SPA navigation
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: pathname,
        page_location: window.location.href,
      });
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/personal-data" element={<PersonalData />} />
      <Route path="/address-data" element={<AddressData />} />
      <Route path="/known-info" element={<KnownInfoSelection />} />
      <Route path="/address-details" element={<AddressDetails />} />
      <Route path="/birthdate" element={<Birthdate />} />
      <Route path="/both-info" element={<BothInfo />} />
      <Route path="/no-info" element={<NoInfo />} />
      <Route path="/email" element={<Email />} />
      <Route path="/loading" element={<Loading />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/bankueberweisung" element={<BankTransfer />} />
      <Route path="/success" element={<Success />} />
      <Route path="/payment-success" element={<Success />} />
      <Route path="/verification-success" element={<VerificationSuccess />} />
      <Route path="/processing" element={<Processing />} />
      <Route path="/legal/:type" element={<Legal />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/agb" element={<AGB />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/lieferungen-leistung" element={<LieferungenLeistung />} />
      <Route path="/widerrufsbelehrung" element={<Widerrufsbelehrung />} />
      <Route path="/kontaktformular" element={<Kontaktformular />} />
      <Route path="/vertrag-widerrufen" element={<VertragWiderrufen />} />
      <Route path="/erfahrungen" element={<Erfahrungen />} />
      
      {/* Einwohnermeldeamt Routes */}
      <Route path="/einwohnermeldeamt" element={<EinwohnermeldeamtIndex />} />
      <Route path="/einwohnermeldeamt/:bundesland" element={<BundeslandPage />} />
      <Route path="/einwohnermeldeamt/:bundesland/:location" element={<LocationPage />} />
      
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes; 